const englishTranslations = {
  hi: {
    title: "Health Information",
    line1: "Please provide your health information.",
    line2:
      "This information is required by the Doctor for medical consultation.",
    line3: "This will take 10-15 minutes.",
    line4: "Please have your height and weight ready before pressing 'Start'.",
    start: "Start",
    other: "Others",
    otherText: "If others, please specify",
    nota: "None of the above",
    yes: "Yes",
    yesText: "If yes please tell us more",
    no: "No",
    submitText1:
      "You have successfully registered for medical consultation with Doctor",
    submitText2: "Submitting information, please wait",
    submit: "Submit",
    updateInfo: "Update Info",
    noInfo: "No health information submitted",
    loadingInfo: "Fetching health information",
  },
  Q1: {
    question: "What is your height?",
  },
  Q2: {
    question: "What is your weight?",
  },
  Q3: {
    question: "Have you ever had following medical conditions?",
    options: {
      Q3C1: "HT (Blood Pressure)",
      Q3C2: "Hypo-Thyroid",
      Q3C3: "CKD (Kidney Disease)",
      Q3C4: "DM (Diabetes)",
      Q3C5: "Dyslipidemia (Cholesterol)",
      Q3C6: "IHD (Ischemic Heart Disease)",
      Q3C7: "None of the above",
    },
  },
  Q4: {
    question: "Are you suffering from any of the following?",
    options: {
      Q4C1: "Acidity",
      Q4C2: "Swelling",
      Q4C3: "Hair Loss",
      Q4C4: "Rash",
      Q4C5: "Ulcers",
    },
  },
  Q5: {
    question: "Any other medical history?",
  },
  Q12: {
    question: "Any surgical history?",
  },
  Q6: {
    question: "Are you currently taking any medication?",
    yesText: "If 'Yes', please write name of the medicines",
  },
  Q7: {
    question: "Do you have any side effects / allergies to any drugs?",
    yesText: "If 'Yes', please specify",
  },
  Q8: {
    question: "Are you taking any supplement?",
    options: {
      Q8C1: "Iron",
      Q8C2: "Calcium",
      Q8C3: "Protein",
    },
    noneText: "Not taking any supplements",
  },
  Q9: {
    question: "How long do you sleep?",
    options: {
      Q9C1: "Less than 6 hours",
      Q9C2: "6 to 8 hours",
      Q9C3: "More than 8 hours",
    },
  },
  Q10: {
    question: "How is the quality of your sleep?",
    options: {
      Q10C1: "Good",
      Q10C2: "Disturbed",
    },
  },
  Q11: {
    question: "How stressed are you?",
    options: {
      Q11C1: "Low",
      Q11C2: "Medium",
      Q11C3: "High",
      Q11C4: "No stress",
      Q11C5: "Sensitive nature",
    },
  },
  Q13: {
    question: "What are your dietary preferences?",
    options: {
      Q13C1: "Vegetarian",
      Q13C2: "Vegetarian + Egg",
      Q13C3: "Non-Vegetarian",
    },
  },
  Q14: {
    question: "What do you eat for breakfast?",
    options: {
      Q14C1: "Tea / Coffee",
      Q14C2: "Poha / Upma",
      Q14C3: "Rice / Idli / Dosa",
      Q14C4: "Bread / Biscuits",
      Q14C5: "Milk / Yogurt / Paneer / Cheese",
      Q14C6: "Dry fruits",
      Q14C7: "Sweets",
      Q14C8: "Fruits",
      Q14C9: "Bhakri / Chapati / Oats / Cornflakes",
      Q14C10: "Vegetables",
      Q14C11: "Dal / Pulses",
      Q14C12: "Non -Veg",
      Q14C13: "Oily / Fried",
      Q14C14: "I don't eat breakfast",
    },
  },
  Q15: {
    question: "At what time do you have your breakfast?",
    options: {
      Q15C1: "Before 7am",
      Q15C2: "7am - 10am",
      Q15C3: "After 10am",
    },
  },
  Q16: {
    question: "What do you eat for lunch?",
    options: {
      Q16C12: "Tea / Coffee",
      Q16C11: "Poha / Upma",
      Q16C5: "Rice / Idli / Dosa",
      Q16C8: "Bread / Biscuits",
      Q16C9: "Milk / Yogurt / Paneer / Cheese",
      Q16C7: "Dry fruits",
      Q16C10: "Fruits",
      Q16C1: "Bhakri / Chapati / Oats / Cornflakes",
      Q16C2: "Vegetables",
      Q16C3: "Dal / Pulses",
      Q16C4: "Non -Veg",
      Q16C6: "Oily / Fried",
      Q16C13: "I don't eat lunch",
    },
  },
  Q17: {
    question: "At what time do you have your lunch?",
    options: {
      Q17C1: "Before 12pm",
      Q17C2: "12pm - 2pm",
      Q17C3: "After 2pm",
    },
  },
  Q18: {
    question: "What do you eat for dinner?",
    options: {
      Q18C12: "Tea / Coffee",
      Q18C11: "Poha / Upma",
      Q18C5: "Rice / Idli / Dosa",
      Q18C8: "Bread / Biscuits",
      Q18C9: "Milk / Yogurt / Paneer / Cheese",
      Q18C7: "Dry fruits",
      Q18C10: "Fruits",
      Q18C1: "Bhakri / Chapati / Oats / Cornflakes",
      Q18C2: "Vegetables",
      Q18C3: "Dal / Pulses",
      Q18C4: "Non -Veg",
      Q18C6: "Oily / Fried",
      Q18C13: "I don't eat dinner",
    },
  },
  Q19: {
    question: "At what time do you eat your dinner?",
    options: {
      Q19C1: "Before 7pm",
      Q19C2: "7pm - 11pm",
      Q19C3: "After 11pm",
    },
  },
  Q20: {
    question: "Do you exercise?",
  },
  Q21: {
    question: "What type of exercise?",
    options: {
      Q21C1: "Joint exercise",
      Q21C2: "Back exercise",
      Q21C3: "Physiotherapy exercise",
      Q21C4: "Walking",
      Q21C5: "Yoga",
    },
  },
  Q22: {
    question: "Have you learnt exercise from a Physiotherapist?",
    yesText: "If yes, when",
  },
};

const marathiTranslations = {
  hi: {
    title: "आरोग्य माहिती",
    line1: "कृपया तुमची आरोग्य माहिती द्या.",
    line2: "वैद्यकीय सत्रासाठी डॉक्टरांना ही माहिती आवश्यक आहे.",
    line3: "यास 10-15 मिनिटे लागतील.",
    line4: "कृपया 'सुरू करा' दाबण्यापूर्वी तुमची उंची आणि वजन तयार ठेवा.",
    start: "सुरू करा",
    other: "इतर",
    otherText: "जर इतर असतील तर, कृपया त्याचा उल्लेख करा.",
    nota: "वरीलपैकी काहीही नाही",
    yes: "हो",
    yesText: "असल्यास कृपया आम्हाला अधिक सांगा",
    no: "नाही",
    submitText1:
      "तुम्ही डॉक्टरांशी वैद्यकीय सत्रासाठी करण्यासाठी यशस्वीपणे नोंदणी केली आहे",
    submitText2: "माहिती सबमिट केली जात आहे. कृपया थांबा",
    submit: "सबमिट करा",
    updateInfo: "माहिती अपडेट करा",
    noInfo: "कोणतीही आरोग्य माहिती सादर केली नाही",
    loadingInfo: "आरोग्य माहिती मिळवत आहे",
  },
  Q1: {
    question: "तुमची उंची किती आहे?",
  },
  Q2: {
    question: "तुमचे वजन किती आहे?",
  },
  Q3: {
    question:
      "तुम्हाला कधीही खालीलपैकी कोणत्याही वैद्यकीय समस्या झाल्या आहेत का?",
    options: {
      Q3C1: "एच .टी (ब्लड प्रेशर)",
      Q3C2: "थायरॉईड",
      Q3C3: "सी के डी (किडनी रोग)",
      Q3C4: "डायबिटीज",
      Q3C5: "डीसलिपिडेमिया (कोलेस्टेरॉल)",
      Q3C6: "आय एच डी (हृदयरोग)",
      Q3C7: "वरीलपैकी काहीही नाही",
    },
  },
  Q4: {
    question: "तुम्हाला खालीलपैकी कोणतीही लक्षणं आहेत का?",
    options: {
      Q4C1: "पित्त",
      Q4C2: "सूज येणे",
      Q4C3: "केस गळणे",
      Q4C4: "पुरळ",
      Q4C5: "व्रण",
    },
  },
  Q5: {
    question: "इतर कोणत्याही वैद्यकीय समस्या आहेत का?",
  },
  Q12: {
    question: "तुमच्यावर कधीही कोणती शस्त्रक्रिया झाली आहे का?",
  },
  Q6: {
    question: "तुम्ही सध्या कोणतीही औषधे घेत आहात का?",
    yesText: "'हो' असल्यास, कृपया औषधांची नावे लिहा",
  },
  Q7: {
    question: "तुम्हाला कोणत्याही औषधांचे साइड इफेक्ट्स/ऍलर्जी आहे का?",
    yesText: "'हो' असल्यास, कृपया अधिक सांगा",
  },
  Q8: {
    question: "तुम्ही कोणतेही सप्लीमेंट घेत आहात का?",
    options: {
      Q8C1: "आयर्न",
      Q8C2: "कॅल्शिअम",
      Q8C3: "प्रोटीन",
    },
    noneText: "कोणतेही सप्लिमेंट घेत नाही",
  },
  Q9: {
    question: "तुम्ही किती वेळ झोपता?",
    options: {
      Q9C1: "6 तासांपेक्षा कमी",
      Q9C2: "6-8 तास",
      Q9C3: "8 तासांपेक्षा जास्त",
    },
  },
  Q10: {
    question: "तुमची झोप कशी आहे?",
    options: {
      Q10C1: "गाढ (शांत)",
      Q10C2: "अस्वस्थ",
    },
  },
  Q11: {
    question: "तुम्हाला किती तणाव असतो?",
    options: {
      Q11C1: "कमी",
      Q11C2: "मध्यम",
      Q11C3: "जास्त",
      Q11C4: "तणाव नाही आहे",
      Q11C5: "संवेदनशील स्वभाव",
    },
  },
  Q13: {
    question: "तुम्ही आहारात काय घेता?",
    options: {
      Q13C1: "शाकाहारी",
      Q13C2: "शाकाहारी + अंडी",
      Q13C3: "मांसाहारी",
    },
  },
  Q14: {
    question: "तुम्ही सकाळी नाश्त्या मध्ये काय खाता?",
    options: {
      Q14C1: "चहा / कॉफी",
      Q14C2: "पोहे / उपमा",
      Q14C3: "भात / इडली / डोसा",
      Q14C4: "ब्रेड / बिस्किटे",
      Q14C5: "दूध / दही / पनीर / चीज",
      Q14C6: "सुखा मेवा (ड्राय फ्रुट्स)",
      Q14C7: "गोड पदार्थ",
      Q14C8: "फळे",
      Q14C9: "भाकरी / चपाती / ओट्स / कॉर्नफ्लेक्स",
      Q14C10: "भाज्या",
      Q14C11: "डाळींचे पदार्थ",
      Q14C12: "मांसाहारी पदार्थ",
      Q14C13: "तेलकट / तळलेले खाद्यपदार्थ",
      Q14C14: "मी नाश्ता करत नाही.",
    },
  },
  Q15: {
    question: "तुम्ही नाश्ता किती वाजता करता?",
    options: {
      Q15C1: "सकाळी 7 च्या आधी",
      Q15C2: "सकाळी 7 ते 10 दरम्यान",
      Q15C3: "सकाळी 10 नंतर",
    },
  },
  Q16: {
    question: "तुम्ही दुपारच्या जेवणात काय खाता?",
    options: {
      Q16C12: "चहा / कॉफी",
      Q16C11: "पोहे / उपमा",
      Q16C5: "भात / इडली / डोसा",
      Q16C8: "ब्रेड / बिस्किटे",
      Q16C9: "दूध / दही / पनीर / चीज",
      Q16C7: "सुखा मेवा (ड्राय फ्रुट्स)",
      Q16C10: "फळे",
      Q16C1: "भाकरी / चपाती / ओट्स / कॉर्नफ्लेक्स",
      Q16C2: "भाज्या",
      Q16C3: "डाळींचे पदार्थ",
      Q16C4: "मांसाहारी पदार्थ",
      Q16C6: "तेलकट / तळलेले खाद्यपदार्थ",
      Q16C13: "मी दुपारचे जेवण खात नाही",
    },
  },
  Q17: {
    question: "तुम्ही दुपारचं जेवण किती वाजता करता?",
    options: {
      Q17C1: "दुपारी 12 च्या आधी",
      Q17C2: "दुपारी 12 ते 2 च्या दरम्यान",
      Q17C3: "दुपारी 2 नंतर",
    },
  },
  Q18: {
    question: "तुम्ही रात्रीच्या जेवणात काय खाता?",
    options: {
      Q18C12: "चहा / कॉफी",
      Q18C11: "पोहे / उपमा",
      Q18C5: "भात / इडली / डोसा",
      Q18C8: "ब्रेड / बिस्किटे",
      Q18C9: "दूध / दही / पनीर / चीज",
      Q18C7: "सुखा मेवा (ड्राय फ्रुट्स)",
      Q18C10: "फळे",
      Q18C1: "भाकरी / चपाती / ओट्स / कॉर्नफ्लेक्स",
      Q18C2: "भाज्या",
      Q18C3: "डाळींचे पदार्थ",
      Q18C4: "मांसाहारी पदार्थ",
      Q18C6: "तेलकट / तळलेले खाद्यपदार्थ",
      Q18C13: "मी रात्रीचे जेवण करत नाही",
    },
  },
  Q19: {
    question: "तुम्ही रात्री किती वाजता जेवता?",
    options: {
      Q19C1: "संध्याकाळी 7 च्या आधी",
      Q19C2: "संध्याकाळी 7 ते 11 च्या दरम्यान",
      Q19C3: "रात्री 11 च्या नंतर",
    },
  },
  Q20: {
    question: "तुम्ही व्यायाम करता का?",
  },
  Q21: {
    question: "व्यायाम कोणत्या प्रकारचा आहे?",
    options: {
      Q21C1: "सांधे व्यायाम",
      Q21C2: "पाठीचे व्यायाम",
      Q21C3: "फिजिओथेरपी व्यायाम",
      Q21C4: "चालणे",
      Q21C5: "योग",
    },
  },
  Q22: {
    question: "तुम्ही फिजिओथेरपिस्टकडून व्यायाम शिकलात का?",
    yesText: "जर होय तर कधी?",
  },
};

const hindiTranslations = {
  hi: {
    title: "स्वास्थ्य जानकारी",
    line1: "कृपया अपने स्वास्थ्य की जानकारी दें।",
    line2: "यह जानकारी डॉक्टर के सत्र के लिए आवश्यक हैं।",
    line3: "इसमें 10-15 मिनट का समय लगेगा।",
    line4: "कृपया 'शुरु करो' दबाने से पहले अपनी ऊंचाई और वजन तैयार रखें।",
    start: "शुरु करो",
    other: "अन्य",
    otherText: "अगर कोई अन्य है, तो कृपया इसका उल्लेख करें।",
    nota: "इनमे से कोई भी नहीं",
    yes: "हाँ",
    yesText: "यदि हां, तो कृपया हमें और बताएँ",
    no: "नहीं",
    submitText1:
      "आपने डॉक्टर के साथ चिकित्सा सत्र के लिए सफलतापूर्वक पंजीकरण कर लिया हैं",
    submitText2: "जानकारी जमा की जा रही है। कृपया प्रतीक्षा करें",
    submit: "इसे जमा करे",
    updateInfo: "जानकारी अपडेट करें|",
    noInfo: "कोई स्वास्थ्य सूचना प्रस्तुत नहीं की गई|",
    loadingInfo: "स्वास्थ्य की जानकारी प्राप्त कर रहे हैं|",
  },
  Q1: {
    question: "आपकी ऊँचाई कितनी हैं?",
  },
  Q2: {
    question: "अपका वज़न कितना हैं?",
  },
  Q3: {
    question: "क्या आपको कभी भी इनमे से कोई बीमारी हुई हैं?",
    options: {
      Q3C1: "एच .टी (ब्लड प्रेशर)",
      Q3C2: "थायरॉईड",
      Q3C3: "सी के डी (किडनी रोग)",
      Q3C4: "डायबिटीज",
      Q3C5: "डीसलिपिडेमिया (कोलेस्टेरॉल)",
      Q3C6: "आय एच डी (हृदयरोग)",
      Q3C7: "इनमे से कोई भी नहीं",
    },
  },
  Q4: {
    question: "क्या आपको इनमे से कोई लक्षण हैं?",
    options: {
      Q4C1: "पित्त",
      Q4C2: "सूजन",
      Q4C3: "बाल झड़ना",
      Q4C4: "खरोंच",
      Q4C5: "व्रण",
    },
  },
  Q5: {
    question: "क्या आप किसी अन्य बीमारी से पीड़ित हैं?",
  },
  Q12: {
    question: "क्या आपकी कभी कोई सर्जरी हुई हैं?",
  },
  Q6: {
    question: "क्या आप अभी कोई दवाईंया ले रहे हैं?",
    yesText: "यदि 'हाँ', तो कृपया दवाईंयों के नाम लिखें",
  },
  Q7: {
    question:
      "क्या आपको किसी दवा से कोई दुष्प्रभाव (साइड इफेक्ट) / एलर्जी हैं?",
    yesText: "यदि 'हाँ', तो कृपया अधिक बताएं",
  },
  Q8: {
    question: "क्या आप कोई सप्लीमेंट ले रहे हैं?",
    options: {
      Q8C1: "आयर्न",
      Q8C2: "कॅल्शिअम",
      Q8C3: "प्रोटीन",
    },
    noneText: "कोई सप्लीमेंट नहीं लेते हें|",
  },
  Q9: {
    question: "आप कितने देर सोते हैं?",
    options: {
      Q9C1: "6 घंटे से कम",
      Q9C2: "6-8 घंटे",
      Q9C3: "8 घंटे से अधिक",
    },
  },
  Q10: {
    question: "आप की नींद कैसी होती हैं?",
    options: {
      Q10C1: "गेहरी",
      Q10C2: "अशान्त",
    },
  },
  Q11: {
    question: "आप कितने तनाव में रेहते हैं?",
    options: {
      Q11C1: "कम",
      Q11C2: "मध्यम",
      Q11C3: "ज्यादा",
      D11C4: "तनाव नहीं है",
      D11C5: "संवेदनशील स्वभाव",
    },
  },
  Q13: {
    question: "आपकी आहार प्राथमिकताएं क्या हैं?",
    options: {
      Q13C1: "शाकाहारी",
      Q13C2: "शाकाहारी + अंडा",
      Q13C3: "मांसाहारी",
    },
  },
  Q14: {
    question: "आप सुबह नाश्ते में क्या खाते हो?",
    options: {
      Q14C1: "चाय कॉफी",
      Q14C2: "पोहा / उपमा",
      Q14C3: "चावल / इडली / डोसा",
      Q14C4: "ब्रेड / बिस्कुट",
      Q14C5: "दूध / दही / पनीर / पनीर",
      Q14C6: "ड्राई फ्रुट",
      Q14C7: "मीठा",
      Q14C8: "फल",
      Q14C9: "ब्रेड / चपाती / ओट्स / कॉर्नफ्लेक्स",
      Q14C10: "सब्ज़ियाँ",
      Q14C11: "दाल",
      Q14C12: "मांसाहारी भोजन",
      Q14C13: "तेल / तला हुआ भोजन",
      Q14C14: "मैं नाश्ता नहीं करता / करतीं",
    },
  },
  Q15: {
    question: "आप नाश्ता कितने बजे करते हो?",
    options: {
      Q15C1: "सुबह 7 बजे से पहले",
      Q15C2: "सुबह 7 से 10 बजे के बीच",
      Q15C3: "सुबह 10 बजे के बाद",
    },
  },
  Q16: {
    question: "आप दोपहर के खाने मे क्या खाते हो?",
    options: {
      Q16C12: "चाय / कॉफी",
      Q16C11: "पोहा / उपमा",
      Q16C5: "चावल / इडली / डोसा",
      Q16C8: "रोटी / बिस्कुट",
      Q16C9: "दूध / दही / पनीर / पनीर",
      Q16C7: "ड्राई फ्रुट",
      Q16C10: "फल",
      Q16C1: "ब्रेड / चपाती / ओट्स / कॉर्नफ्लेक्स",
      Q16C2: "सब्ज़ियाँ",
      Q16C3: "दाल",
      Q16C4: "मांसाहारी भोजन",
      Q16C6: "तेल / तला हुआ भोजन",
      Q16C13: "मैं दोपहर का खाना नहीं खाता / खाती",
    },
  },
  Q17: {
    question: "आप कितने बजे दोपहर का खाना खाते हो?",
    options: {
      Q17C1: "दोपहर 12 बजे से पहले",
      Q17C2: "दोपहर 12 बजे से 2 बजे के बीच",
      Q17C3: "दोपहर 2 बजे के बाद",
    },
  },
  Q18: {
    question: "आप रात के खाने मे क्या खाते हो?",
    options: {
      Q18C12: "चाय / कॉफी",
      Q18C11: "पोहा / उपमा",
      Q18C5: "चावल / इडली / डोसा",
      Q18C8: "रोटी / बिस्कुट",
      Q18C9: "दूध / दही / पनीर / पनीर",
      Q18C7: "ड्राई फ्रुट",
      Q18C10: "फल",
      Q18C1: "ब्रेड / चपाती / ओट्स / कॉर्नफ्लेक्स",
      Q18C2: "सब्ज़ियाँ",
      Q18C3: "दाल",
      Q18C4: "मांसाहारी भोजन",
      Q18C6: "तेल / तला हुआ भोजन",
      Q18C13: "मैं रात का खाना नहीं खाता / खाती",
    },
  },
  Q19: {
    question: "आपका रात का खाना कितने बजे होता हैं?",
    options: {
      Q19C1: "शाम 7 बजे से पहले",
      Q19C2: "शाम 7 बजे से 11 बजे के बीच",
      Q19C3: "रात 11 बजे के बाद",
    },
  },
  Q20: {
    question: "क्या आप व्यायाम करते हैं?",
  },
  Q21: {
    question: "किस प्रकार का व्यायाम?",
    options: {
      Q21C1: "जोड़ों का व्यायाम",
      Q21C2: "पीठ का व्यायाम",
      Q21C3: "फफिजियोथेरेपी व्यायाम",
      Q21C4: "चलना",
      Q21C5: "योग",
    },
  },
  Q22: {
    question: "क्या आपने किसी फिजियोथेरेपिस्ट से व्यायाम सीखा हैं?",
    yesText: "यदि हां, तो कब?",
  },
};

const yesCodes = ["Q5C1", "Q12C1", "Q6C1", "Q7C1", "Q22C1"];

const yesCodesWithoutResponse = ["Q20C1"];

const noCodes = ["Q5C2", "Q12C2", "Q6C2", "Q7C2", "Q20C2", "Q22C2"];

const otherCodes = ["Q4C6", "Q8C4"];

const noneCodes = ["Q4C7", "Q8C5"];

export const translations = {
  EN: englishTranslations,
  MR: marathiTranslations,
  HI: hindiTranslations,
  metaData: {
    yesCodes: yesCodes,
    noCodes: noCodes,
    yesCodesWR: yesCodesWithoutResponse,
    otherCodes: otherCodes,
    noneCodes: noneCodes,
  },
};
